import { MutationCache, QueryClient } from "@tanstack/react-query";

export const queryClient: QueryClient = new QueryClient({
  // Any save can change what is waiting (a truck passed in, a sample drawn, a slip previewed), so
  // the top menu's badges refresh after every successful write rather than on the next poll.
  mutationCache: new MutationCache({
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["nav", "counts"] }),
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (count, err) => {
        // Never retry client errors; the server already told us what is wrong.
        const status = (err as { status?: number }).status;
        return status === undefined || status >= 500 ? count < 2 : false;
      },
    },
  },
});
